export const MAX_TEXT_LENGTH = 5000;
export const SNACKBAR_TIME = 5000;

export const SNACKBAR_LIMIT_TEXT_1 = 'Вы достигли лимита по длине текста. Чтобы продолжить писать сократите текст';
export const SNACKBAR_LIMIT_TEXT_2 = 'Ваш текст не может быть добавлен, так как он превышает лимит текста';
